export class Branch {
    policyProductCode: string;
    policyTypeCode: string;
    description: string;
}
